import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { invalid } from '@angular/compiler/src/render3/view/util';
import { HttpClient, HttpParams } from '@angular/common/http';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material';
import { Source } from '../models/sources.model';
import { Reporting } from '../models/report.model';
import * as XLSX from 'xlsx';
import { DaterangeInterface } from '../daterange-interface';
import { Router } from '@angular/router';


@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.css']
})


export class ReportsComponent implements OnInit {

  sources: Source[] = [];
  report: Reporting[] = [];
  http: HttpClient;
  baseURL = '';
  errorStart: boolean = false;
  errorEnd: boolean = false;
  error: boolean = false;
  dataCount: number = 0;
  noReportData: boolean = true;
  noData: boolean = false;
  loading: boolean = true;
  reportColumns: string[] = ['source', 'date', 'visitors', 'registrations', 'inquirers', 'leads', 'returned', 'valid', 'price'];


  @ViewChild('ReportTableSort', { static: true }) reportTableSort: MatSort;
  @ViewChild('ReportTablePaginator', { static: true }) reportTablePaginator: MatPaginator;




  dtReport = new MatTableDataSource();


  constructor(@Inject(HttpClient) http: HttpClient, @Inject('BASE_URL') baseUrl: string, @Inject(Router) _router: Router) {
    this.baseURL = baseUrl;
    this.http = http;
    this.router = _router;
  }


  authenticated: string = "";
  router: Router;
  navigation: any;


  dates: DaterangeInterface = {
    startDate: null,
    endDate: null
  };

  ngOnInit() {

    this.authenticated = sessionStorage.getItem('intcontId')

    if (this.authenticated == "0") {
      this.router.navigate(['/', 'login']);
    } else {
      this.Getsources();

      var date = new Date();
      var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);

      this.dates.startDate = firstDay;
      this.dates.endDate = date;

    }

  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.Submit(this.dates);
    }, 300);

  }

  toggleChanged: boolean = false;
  sidebarOpen: boolean = false;

  toggleNav() {

    this.toggleChanged = !this.toggleChanged;
    this.sidebarOpen = !this.sidebarOpen;
  }


  Getsources() {
    var internalContactId = sessionStorage.getItem('intcontId');


    let params = new HttpParams();
    params = params.append('InternalContactId', internalContactId);


    //GET Sources
    this.http.get(this.baseURL + 'api/Leads/GetSources', { params: params }).subscribe(data => {

      var keys = Object.keys(data);
      var len = keys.length;

      
      if (len > 1) {
        this.sources.push({ sourceId: 0, name: "All Sources" });
      }


      for (var i = 0; i <= len - 1; i++) {
        var sourceId = data[i]["sourceId"];
        var name = data[i]["name"];

        this.sources.push({ sourceId: sourceId, name: name });

      }
    });
  }

  Submit(dates) {
    this.noData = false;
    var internalContactId = sessionStorage.getItem('intcontId');

    let startDate = dates.startDate;
    let endDate = dates.endDate;
    let startString = this.formatDate(dates.startDate);
    let endString = this.formatDate(dates.endDate);
    let sourceId = (document.getElementById("ddSource") as HTMLInputElement).value;

    this.errorStart = false;
    this.errorEnd = false;
    this.error = false;
    this.report = [];


    if (startDate != null && endDate != null && sourceId != null) {
      //Check that the end date is greater than start date
      if (startString === endString || endDate > startDate) {
        //Good

        //var hawkeyeUserId = sessionStorage.getItem('heuid');
        //var hawkeyeRoleId = sessionStorage.getItem('herole');

        let params = new HttpParams();
        params = params.append("SourceId", sourceId);
        params = params.append('InternalContactId', internalContactId);
        params = params.append('StartDate', startString);
        params = params.append('EndDate', endString);

        this.GetReportData(params);


      } else {
        if (dates.startDate == "") {
          this.errorStart = true;
        } else if (dates.endDate == "") {
          this.errorEnd = true;
        } else {
          this.errorStart = true;
          this.errorEnd = true;
          this.error = true;
        }
      }
    } else {
      
    }

  }


  GetReportData(params) {
    this.report = [];


    this.http.get(this.baseURL + 'api/Report/GetPartnerDailyReport', { params: params }).subscribe(data => {

      var dataLength = Object.keys(data).length;
      if (dataLength > 0) {
        this.dataCount = dataLength;

        var keys = Object.keys(data);
        var len = keys.length;


        if (len > 0) {
          for (var i = 0; i <= len - 1; i++) {
            var source = data[i]["source"];
            var date = data[i]["date"];
            var visitors = data[i]["visitors"];
            var registrations = data[i]["registrations"];
            var inquirers = data[i]["inquirers"];
            var leads = data[i]["leads"];
            var returned = data[i]["returned"];
            var valid = data[i]["valid"];
            var price = data[i]["price"];


            this.report.push({source: source, date: date, visitors: visitors, registrations: registrations, inquirers: inquirers, leads: leads, returned: returned, valid: valid, price: price });

          }
          this.loading = false;
          this.noReportData = false;
          this.dtReport = new MatTableDataSource(this.report);
          this.dtReport.paginator = this.reportTablePaginator;
          this.dtReport.sort = this.reportTableSort;
        } else {
          //No data retrieved.
          this.report = [];
          this.noReportData = true;
          this.noData = true;
        }


      } else {
        this.noData = true;
        this.noReportData = true;
        this.dataCount = 0;
      }
    });
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dtReport.filter = filterValue.trim().toLowerCase();

    if (this.dtReport.paginator) {
      this.dtReport.paginator.firstPage();
    }
  }

  exportReportData(dates) {

    this.report = [];

    var internalContactId = sessionStorage.getItem('intcontId');
    let startString = this.formatDate(dates.startDate);
    let endString = this.formatDate(dates.endDate);
    let sourceId = (document.getElementById("ddSource") as HTMLInputElement).value;
    var e = (document.getElementById("ddSource")) as HTMLSelectElement;
    var sel = e.selectedIndex;
    var opt = e.options[sel];
    var sourceName = (<HTMLOptionElement>opt).text;


    let params = new HttpParams();
    params = params.append("SourceId", sourceId);
    params = params.append('InternalContactId', internalContactId);
    params = params.append('StartDate', startString);
    params = params.append('EndDate', endString);


    this.http.get(this.baseURL + 'api/Report/GetPartnerDailyReport', { params: params }).subscribe(data => {



      var dataLength = Object.keys(data).length;
      if (dataLength > 0) {
        this.dataCount = dataLength;

        var keys = Object.keys(data);
        var len = keys.length;




        if (len > 0) {
          for (var i = 0; i <= len - 1; i++) {
            var source = data[i]["source"];
            var date = data[i]["date"];
            var visitors = data[i]["visitors"];
            var registrations = data[i]["registrations"];
            var inquirers = data[i]["inquirers"];
            var leads = data[i]["leads"];
            var returned = data[i]["returned"];
            var valid = data[i]["valid"];
            var price = data[i]["price"];


            this.report.push({source: source, date: date, visitors: visitors, registrations: registrations, inquirers: inquirers, leads: leads, returned: returned, valid: valid, price: price });

          }



          var d = new Date();
          var n = this.formatDate(d);

          let fileName = sourceName + '_DailyTotals_' + n;
          let sheetName = "DailyTotals";

          var wb = XLSX.utils.book_new();
          var ws = XLSX.utils.json_to_sheet(this.report);
          XLSX.utils.book_append_sheet(wb, ws, sheetName);
          XLSX.writeFile(wb, `${fileName}.xlsx`);
        }

      }

    });
  }

  formatDate(date) {
    var d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2)
      month = '0' + month;
    if (day.length < 2)
      day = '0' + day;

    return [year, month, day].join('-');
  }

}
